import { PasswordReset } from 'ui/components/buyer/patterns/PasswordReset/PasswordReset';

/**
 * パスワードリセットページ
 */
export const BuyerUserPasswordReset: React.FC = () => {
    return <PasswordReset />;
};
